export const siteData = {
  brand: {
    name: "Booze to Beast",
    tagline: "Stop Boozing. Start Living.",
    domain: "boozetobeast.com",
    logoIcon: "https://customer-assets.emergentagent.com/job_transformation-hub-7/artifacts/7iojslat_Artboard%201%20copy%203.png",
    logoFull: "https://customer-assets.emergentagent.com/job_transformation-hub-7/artifacts/opw26tu0_Artboard%201%20copy%208.png",
  },
  hero: {
    headline: "This Is For Men Who Are Done.",
    subheadline: "Not cutting back. Not moderating. Done.",
    description: "Booze to Beast is a 16-week program that removes alcohol from your life by fixing the reason it was there in the first place.",
    cta: "Apply Now",
    secondaryCta: "Learn More",
  },
  about: {
    title: "What is Booze to Beast?",
    description: "Booze to Beast is a 16-week program for men who want to stop boozing for good. Not control. Not cutting back. Not rules.",
    highlight: "We remove booze by fixing the reason it's there \u2014 so you don't need it anymore.",
  },
  whoFor: {
    title: "Who This Is For",
    isFor: [
      "Men who know booze has to go",
      "Men tired of restarting",
      "Men who want a clear head and self-respect back",
      "Men willing to change routines, not just habits",
    ],
    isNotFor: [
      "Anyone wanting to cut back",
      "Anyone wanting rules or moderation",
      "Anyone not ready to change how they live",
      "Anyone who keeps making excuses",
    ],
    bottomLine: "This is for men who are done, not debating.",
  },
  realProblem: {
    title: "The Real Problem",
    intro: "Alcohol isn't your real issue.",
    description: "It's the tool you've been using to:",
    points: [
      "Switch off",
      "Cope with stress",
      "Avoid emotion",
      "Fill space",
    ],
    solution: "Booze to Beast doesn't just remove alcohol. It replaces the identity that needed it.",
  },
  transformation: {
    title: "I've Been Where You Are",
    subtitle: "This isn't theory. I lived it.",
    before: {
      label: "The Booze",
      images: [
        {
          url: "https://customer-assets.emergentagent.com/job_transformation-hub-7/artifacts/imqi9qol_31a6ff3b-b359-48af-b340-9cdeed44aac9%204.JPG",
          alt: "Marcus Jones before sobriety - struggling with alcohol addiction UK"
        },
        {
          url: "https://customer-assets.emergentagent.com/job_transformation-hub-7/artifacts/2qub8asg_d8f5bcdb-011e-40a3-ba01-44f75f60bc4c%202.JPG",
          alt: "Before photo - life affected by drinking, UK men's alcohol recovery story"
        },
        {
          url: "https://customer-assets.emergentagent.com/job_transformation-hub-7/artifacts/p2qh6gtv_IMG_1833.JPG",
          alt: "Marcus before Booze to Beast transformation - unhealthy lifestyle from alcohol"
        },
      ],
    },
    after: {
      label: "The Beast",
      images: [
        {
          url: "https://customer-assets.emergentagent.com/job_transformation-hub-7/artifacts/l528swfk_56A493D1-CA1F-40E7-A63E-685AD7BCD0B3.JPG",
          alt: "Marcus Jones after quitting alcohol - running marathon sober coach UK"
        },
        {
          url: "https://customer-assets.emergentagent.com/job_transformation-hub-7/artifacts/8t1po8yk_88612532-fcc8-431c-848a-d8a0cc2ac6a6%202.JPG",
          alt: "Marcus Jones transformation - healthy and confident after stopping drinking"
        },
        {
          url: "https://customer-assets.emergentagent.com/job_transformation-hub-7/artifacts/kj3vuvc1_b5c341ab-9649-4895-9a33-49856be39eea%203.JPG",
          alt: "Booze to Beast founder Marcus Jones - Jurassic Coast Ultra Challenge finisher sober"
        },
      ],
    },
  },
  system: {
    title: "The Booze to Beast System",
    subtitle: "Built like a game. You don't unlock the next level until you've completed the one you're on.",
    rules: [
      "No rushing",
      "No skipping",
      "No pretending you've 'got it'",
    ],
    benefits: [
      "Reduce overwhelm",
      "Force implementation",
      "Build confidence through action",
    ],
    highlight: "You focus on one job at a time, and you move forward only when it's done. That's how change sticks.",
  },
  focus: {
    title: "What We Focus On",
    areas: [
      {
        title: "Remove the Need",
        description: "Removing the need for booze at its root, not white-knuckling through cravings.",
      },
      {
        title: "Calm Your Body",
        description: "Calming your body when urges hit so they pass without spiraling.",
      },
      {
        title: "Handle Stress",
        description: "Dealing with stress and emotion properly \u2014 without numbing.",
      },
      {
        title: "Change the Moments",
        description: "Changing the moments that kept pulling you back to the bottle.",
      },
      {
        title: "Rebuild Trust",
        description: "Rebuilding trust in yourself through consistent action.",
      },
    ],
    bottomLine: "When those change, booze loses its grip.",
  },
  outcomes: {
    title: "The Outcomes",
    subtitle: "By the end of Booze to Beast, most men experience:",
    results: [
      "No constant mental debate about drinking",
      "Urges that pass instead of spiral",
      "Calm evenings and better sleep",
      "Better energy and focus",
      "More patience and presence",
      "Real self-respect again",
    ],
    highlight: "You're not managing sobriety. You're living without booze.",
  },
  structure: {
    title: "The Structure",
    subtitle: "16 Weeks. 3 Phases. One Transformation.",
    phases: [
      {
        number: "01",
        name: "Demolition",
        weeks: "Weeks 1\u20134",
        tagline: "Stability. Control. Clarity.",
        description: "Stop the bleed. Remove what's actively keeping you stuck. Break the automatic drinking cycle, understand your triggers, and create structure so you're not relying on willpower.",
        feel: "Grounded. Back in control. Clear on what needs to change.",
      },
      {
        number: "02",
        name: "Construction",
        weeks: "Weeks 5\u201310",
        tagline: "Confidence. Momentum. Self-Respect.",
        description: "Build a life that makes sense without alcohol. Identity shift, daily habits, emotional resilience, handling social situations, and rebuilding trust in yourself through consistency.",
        feel: "Momentum building. Stronger in yourself. Proud of who you're becoming.",
      },
      {
        number: "03",
        name: "Armoring",
        weeks: "Weeks 11\u201316",
        tagline: "Resilience. Ownership. Permanence.",
        description: "Future-proof your transformation. Handle high-pressure situations, advanced trigger management, set personal boundaries, and step into leadership in your own life.",
        feel: "Strong. Capable. Calm under pressure. This is who you are now.",
      },
    ],
    summary: "Remove what doesn't work. Build what does. Protect it for life.",
  },
  effort: {
    title: "The Effort",
    intro: "This isn't passive. You'll need to:",
    requirements: [
      "Show up",
      "Practice simple tools daily",
      "Be honest with yourself",
      "Change routines that no longer serve you",
    ],
    highlight: "You don't need willpower. You do need commitment. If you do the work, the process works.",
  },
  testimonials: {
    title: "What The Lads Say",
    video: {
      url: "https://customer-assets.emergentagent.com/job_transformation-hub-7/artifacts/ekrmue6i_WhatsApp%20Video%202026-01-14%20at%2018.02.29%20%281%29.mp4",
      quote: "Every area of my life has been transformed. Working with Marcus has been a non-judgmental place to be supported. He's a great guy who walks the talk.",
      name: "George",
      duration: "120+ days sober",
    },
    items: [
      {
        quote: "First Christmas since 2002 that I have not bought any alcohol or drunk any since starting my sobriety journey. A healthy transformation.",
        name: "John",
        result: "Sober since Oct 2025",
      },
      {
        quote: "Before getting in contact with Marcus, I struggled with addiction. I was too ashamed and embarrassed to admit it out of fear what others would think. Once I got speaking to Marcus, I felt at home with someone who understood me and wanted to support me. He's really helped with offsetting my negative mindset and celebrating the small wins. Since joining, my confidence has started to grow. Marcus is an open, honest, brilliant person who has a true desire to help others.",
        name: "Harry",
        result: "Growing in confidence",
      },
      {
        quote: "Before I signed up I struggled with maintaining a routine and discipline enabling me to live a sober life. Being mentored by Marcus and being surrounded by positive like-minded people has been a game changer. I've had a sober new year and holiday for the first time I can remember and I am now training towards a marathon in Rome. I have saved money and I am building a better relationship with my children. I would highly recommend to anyone struggling with alcohol.",
        name: "Liam",
        result: "Training for a marathon",
      },
      {
        quote: "Before signing up, I struggled with alcohol and acting on impulse. I knew this program was what I needed, but it was also down to me to help myself with discipline. Once I joined the program I got the help I needed from Marcus and our lovely group. Since joining, my wins are doubling up by the day. This program is perfect for people who want to get sober and put the work in and see their life change drastically for the better.",
        name: "Rory",
        result: "Wins doubling by the day",
      },
    ],
  },
  faq: {
    title: "Frequently Asked Questions",
    items: [
      {
        question: "Is this about moderation or control?",
        answer: "No. This is for men who want booze out of their life. Completely.",
      },
      {
        question: "Do I need to quit before starting?",
        answer: "No. You'll stop during the program, with structure and support.",
      },
      {
        question: "Is this therapy or AA?",
        answer: "No. This is practical coaching and training. No labels, no 12-step programs.",
      },
      {
        question: "What if I mess up?",
        answer: "We deal with it properly and move forward \u2014 without shame.",
      },
      {
        question: "How much time does it take per day?",
        answer: "The daily tools take minutes, not hours. The real work is changing how you live \u2014 and that happens inside your existing day.",
      },
    ],
  },
  investment: {
    title: "The Investment",
    fullPrice: "\u00a31,297",
    splitPrice: "\u00a31,400",
    splitNote: "Split payment option",
    includes: [
      "Your health",
      "Your relationships",
      "Your energy",
      "Your self-respect",
      "A booze-free life",
    ],
    noUpsells: "No upsells. No games.",
  },
  guarantee: {
    title: "Our Guarantee",
    description: "If you show up, do the work, and after the first 30 days this genuinely isn't for you:",
    points: [
      "You get your money back",
      "And I'll continue to coach you for free",
    ],
    bottomLine: "No pressure. No traps. Built on trust.",
  },
  apply: {
    title: "Ready to Start?",
    subtitle: "Complete the short application. I review it personally.",
    description: "If it's a fit, we have a straightforward conversation. If it's not right, I'll tell you.",
    bottomLine: "Simple. Honest. Clear.",
    cta: "Submit Application",
  },
  confirmation: {
    depositAmount: "\u00a3250",
    message: "We take a \u00a3250 deposit to secure your space on the next intake \u2014 if your application is successful, this is your first month in Booze to Beast paid for. If your application is unsuccessful or you change your mind, we'll send you a full immediate refund.",
  },
  images: {
    marcusAfterMain: {
      url: "https://customer-assets.emergentagent.com/job_transformation-hub-7/artifacts/l528swfk_56A493D1-CA1F-40E7-A63E-685AD7BCD0B3.JPG",
      alt: "Marcus Jones - UK sober coach and Booze to Beast founder running marathon"
    },
    marcusCafe: {
      url: "https://customer-assets.emergentagent.com/job_transformation-hub-7/artifacts/ott1u43e_P1063931%202.JPG",
      alt: "Marcus Jones - sober coach UK helping men quit drinking"
    },
    marcusSuit: {
      url: "https://customer-assets.emergentagent.com/job_transformation-hub-7/artifacts/8t1po8yk_88612532-fcc8-431c-848a-d8a0cc2ac6a6%202.JPG",
      alt: "Marcus Jones professional photo - alcohol recovery coach for men UK"
    },
    methodology: {
      url: "https://customer-assets.emergentagent.com/job_transformation-hub-7/artifacts/uzkfq16p_Screenshot%202026-02-18%20at%2017.37.42.png",
      alt: "Booze to Beast methodology - mind body behaviour approach to quit drinking"
    },
    reliefQuote: {
      url: "https://customer-assets.emergentagent.com/job_transformation-hub-7/artifacts/r1wj3o3n_Screenshot%202026-02-18%20at%2017.36.31.png",
      alt: "Most men don't drink for fun they drink for relief - Marcus Jones sober coaching quote"
    },
  },
};
